import { SelectQueryBuilder } from 'typeorm'

import { Role } from '@things-factory/auth-base'
import { getRepository, ListParam } from '@things-factory/shell'

import { TutorialRole } from '../../../entities'

export const listByRolesResolver = {
  async listByRoles(_: any, params: ListParam, context: ResolverContext) {
    const qb: SelectQueryBuilder<TutorialRole> = getRepository(TutorialRole)
      .createQueryBuilder('tr')
      .select('tr.role_id', 'id')
      .addSelect('r.name', 'name')
      .innerJoin(Role, 'r', 'r.id = tr.role_id')
      .groupBy('tr.role_id')
      .addGroupBy('r.name')

    let data = await qb.getRawMany()
    return data
  }
}
